import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { ROUTES } from '../constants/routes';

interface Props {
  children: React.ReactNode;
}

// Allows access ONLY if the user is authenticated AND must_change_password is true.
// Any other state redirects away.
export default function MustChangePasswordGuard({ children }: Props) {
  const token = useAuthStore((s) => s.token);
  const user = useAuthStore((s) => s.user);

  if (!token || !user) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (!user.must_change_password) {
    if (useAuthStore.getState().isIcBroker()) {
      return <Navigate to={ROUTES.BROKER_DASHBOARD} replace />;
    }
    return <Navigate to={user.onboarding_completed ? ROUTES.DASHBOARD : ROUTES.ONBOARDING} replace />;
  }

  return <>{children}</>;
}
